// @ts-nocheck
import { Box } from '@mui/material';
import { XGButton } from '@xg-cl/xg-cl';
import { useTranslation } from 'react-i18next';
import { PlusCircle } from '@phosphor-icons/react';
import './AmenitiesPanel.css';
import AmenitiesTable from '../AmenitiesTable/AmenitiesTable';
import DeleteModal from '../../../Trip/DeleteModal/DeleteModal';
import useGlobalAmenities from '../../../../hooks/useGlobalAmenities';
import { DragDropContext } from 'react-beautiful-dnd';
import { GLOBAL_AMENITIES_TABLE_DROPPABLE_ID } from '../../../../constants/dragAndDrop';

/**
 * Functional React component for rendering a trip additional content component
 *
 * @namespace Components
 *
 * @param {Object} props - The component's properties
 * @param {...any} props.rest - Additional props to be spread on the element
 *
 * @returns {JSX.Element} React element representing the trip additional content component
 */
const Amenities = () => {
  const { t } = useTranslation(['trip', 'common', 'errors']);
  const {
    amenitiesList,
    isSubmitting,
    isAddAmenityFormVisible,
    isDeleteModalOpen,
    handleDeleteAmenityConfirmation,
    handleUpdateAmenity,
    handleDeleteAmenity,
    handleUpdateSequence,
    setIsAddAmenityFormVisible,
    setAmenitiesList,
    setIsDeleteModalOpen,
    setDeleteAmenityId
  } = useGlobalAmenities();

  const onDragEnd = (result) => {
    const { source, destination } = result;

    // If dropped outside a droppable area or at the same position, do nothing
    if (
      !destination ||
      (source.droppableId === destination.droppableId &&
        source.index === destination.index)
    ) {
      return;
    }

    // If reordering amenities
    if (
      source.droppableId === destination.droppableId &&
      source.droppableId === GLOBAL_AMENITIES_TABLE_DROPPABLE_ID
    ) {
      const sourceAmenity = amenitiesList[source.index];
      const destinationAmenity = amenitiesList[destination.index];

      if (sourceAmenity && destinationAmenity) {
        handleUpdateSequence(sourceAmenity, destinationAmenity);
      }
    }
  };

  return (
    <>
      <Box className='global-amenities-box-container'>
        <Box style={{ paddingBottom: '24px' }}>
          <XGButton
            autoFocus
            id='button-add-amenity'
            text={t('addAmenity')}
            type='primary'
            size='large'
            variant='contained'
            onClick={() => setIsAddAmenityFormVisible(true)}
            startIcon={<PlusCircle size={20} />}
          />
        </Box>

        <DragDropContext onDragEnd={onDragEnd}>
          <AmenitiesTable
            amenitiesList={amenitiesList}
            handleUpdateSequence={handleUpdateSequence}
            updateAmenity={handleUpdateAmenity}
            handleDelete={handleDeleteAmenity}
            isDropDisabled={isSubmitting}
            isAddAmenityFormVisible={isAddAmenityFormVisible}
            setAmenitiesList={setAmenitiesList}
            toggleVisibility={() => setIsAddAmenityFormVisible(false)}
            droppableId={GLOBAL_AMENITIES_TABLE_DROPPABLE_ID}
          />
        </DragDropContext>
      </Box>
      <DeleteModal
        id='delete-amenity-modal'
        isOpenModal={isDeleteModalOpen}
        title={t('settings:deleteAmenity')}
        onConfirm={handleDeleteAmenityConfirmation}
        onCancel={() => {
          setIsDeleteModalOpen(false);
          setDeleteAmenityId(null);
        }}
        description={`${t('settings:deleteAmenityConfirmation')} ${t(
          'common:thisActionCannotBeUndone'
        )}`}
        isSubmitting={isSubmitting}
      />
    </>
  );
};

export default Amenities;
